module.exports = {
  background: "#ffffff",
  white: "#ffffff",
  accent: "#709425",
  bright: "#ffffff",
  dark: "#333333",
  gray: "#555555",
  lightGray: "#bbbbbb",
  superLightGray: "#dedede"
};



// WEBPACK FOOTER //
// ./src/styles/colors.js